<template>
  <div class="saving-details">
    <button class="btn-cancel" v-if="!disabled" @click="cancel">
      <v-icon :color="disabled ? '#D0D3DA' : '#f83356'" dark small>
        mdi-delete-outline
      </v-icon>
      <div class="label-cancel">
        Discard Changes
      </div>
    </button>
    <button class="btn-save-details" v-if="!disabled" @click="save">
      <div class="label-save">
        Save Changes
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SaveCancelSection',
  props: {
    disabled: Boolean,
    cancel: Function,
    save: Function,
  },
};
</script>

<style lang="scss" scoped>
.saving-details {
  display: inline-flex;
  gap: 19px;

  .btn-save-details {
    align-items: center;
    display: inline-flex;
    gap: 4px;
    padding: 8px 16px;
    border-radius: 4px;
    background-color: $NBLUE110;
    .label-save {
      color: white;
      font-family: "Poppins", Helvetica;
      font-size: 14px;
      font-weight: 500;
    }

    &:disabled {
      .label-save {
        color: #8990A2;
      }
    }
  }

  .btn-cancel {
    align-items: center;
    display: inline-flex;
    flex: 0 0 auto;
    gap: 4px;
    padding: 8px 16px;
    border-radius: 4px;
    border: 2px solid #EF5B52;

    .label-cancel {
      color: #f83356;
      font-family: "Poppins", Helvetica;
      font-size: 14px;
      font-weight: 500;
    }

    &:disabled {
      .label-cancel {
        color: #8990A2;
      }
    }
  }
}
</style>
